import {
  getConfirmOrderInfo,
  shopDeliveryList,
  toFreightAmountNew,
  queryShopByAxis,
  getEnterpriseList,
  updateEnterprise,
  queryAddrList,
  alterDelivery,
  updateAddr,
  deleteAddr,
  addAddr,
  compareAddr,
  promotionDtl,
  orderSubmit
} from "@/api/order/confirmOrder";

export default {
  namespaced: true,
  state: {
    list: []
  },
  actions: {
    async getConfirmOrderInfo(context, params) {
      const data = await getConfirmOrderInfo(params);
      return data;
    },
    async shopDeliveryList(context, params) {
      const data = await shopDeliveryList(params);
      return data;
    },
    async toFreightAmountNew(context, params) {
      const data = await toFreightAmountNew(params);
      return data;
    },
    async queryShopByAxis(context, params) {
      const data = await queryShopByAxis(params);
      return data;
    },
    async getEnterpriseList(context, params) {
      const data = await getEnterpriseList(params);
      return data;
    },
    async updateEnterprise(context, params) {
      const data = await updateEnterprise(params);
      return data;
    },
    async queryAddrList(context, params) {
      const data = await queryAddrList(params);
      return data;
    },
    async alterDelivery(context, params) {
      const data = await alterDelivery(params);
      return data;
    },
    async updateAddr(context, params) {
      const data = await updateAddr(params);
      return data;
    },
    async deleteAddr(context, params) {
      const data = await deleteAddr(params);
      return data;
    },
    async addAddr(context, params) {
      const data = await addAddr(params);
      return data;
    },
    async compareAddr(context, params) {
      const data = await compareAddr(params);
      return data;
    },
    async promotionDtl(context, params) {
      const data = await promotionDtl(params);
      return data;
    },
    async orderSubmit(context, params) {
      const data = await orderSubmit(params);
      return data;
    }
  }
};
